module.exports = __webpack_public_path__ + "static/angela-673f0c1ad960a1d062afac86c69112dc.png";